var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardCalendarIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8177 3.33073H15.9844V1.66406H14.3177V3.33073H7.65104V1.66406H5.98438V3.33073H5.15104C4.22604 3.33073 3.49271 4.08073 3.49271 4.9974L3.48438 16.6641C3.48438 17.5807 4.22604 18.3307 5.15104 18.3307H16.8177C17.7344 18.3307 18.4844 17.5807 18.4844 16.6641V4.9974C18.4844 4.08073 17.7344 3.33073 16.8177 3.33073ZM16.8177 16.6641H5.15104V8.33073H16.8177V16.6641ZM16.8177 6.66406H5.15104V4.9974H16.8177V6.66406ZM8.48438 11.6641H6.81771V9.9974H8.48438V11.6641ZM11.8177 11.6641H10.151V9.9974H11.8177V11.6641ZM15.151 11.6641H13.4844V9.9974H15.151V11.6641ZM8.48438 14.9974H6.81771V13.3307H8.48438V14.9974ZM11.8177 14.9974H10.151V13.3307H11.8177V14.9974ZM15.151 14.9974H13.4844V13.3307H15.151V14.9974Z",
    fill: "#275778"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCalendarIcon2);
export default __webpack_public_path__ + "static/media/dashboard-calendar-icon-2.74c98d242bb314e4770c7f95fb6aad60.svg";
export { ForwardRef as ReactComponent };